import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR } from 'utils/colors';
import { getScreenSize, isTablet, screenWidth } from 'utils/responsiveness';

import { PHONE_GALLERY_HEIGHT } from '../../styles';

const width = getScreenSize('width');

const styles = StyleSheet.create({
    container: {
        height: PHONE_GALLERY_HEIGHT,
        width: screenWidth,
        justifyContent: 'flex-end',
    },
    image: {
        width,
        height: 203,
    },
    imageContainer: { position: 'absolute', top: 0, left: 0, right: 0 },
    gradientBottomPhone: {
        position: 'absolute',
        bottom: 0,
    },
    linerGradient: {
        flex: 1,
        width: '100%',
        height: 96,
    },
    titleText: {
        alignSelf: 'center',
        justifyContent: 'center',
        height: 'auto',
        marginLeft: 16,
        marginRight: 16,
        textAlign: 'center',
        lineHeight: 40,
    },
    gradientTopPhone: {
        position: 'absolute',
        top: 0,
        height: 96,
        opacity: 0.7,
    },
    metadataText: {
        alignSelf: 'center',
        justifyContent: 'center',
        marginLeft: 16,
        marginRight: 16,
        marginTop: 10,
        textAlign: 'center',
    },
    markerContainer: {
        marginTop: 28,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    marker: {
        width: 'auto',
        marginLeft: 8,
        marginRight: 12,
        height: 20,
        borderRadius: 20,
        alignSelf: isTablet ? 'flex-start' : 'center',
        justifyContent: 'center',
        alignItems: 'center',
    },
    markerIcons: {
        marginLeft: 8,
        marginRight: 8,
    },
    qualifiers: { alignSelf: 'center', marginTop: 18 },
    chLogo: {
        justifyContent: 'center',
        alignSelf: 'center',
        width: 77,
        height: 32,
    },
    moreInfoText: {
        marginLeft: 10,
        color: COLOR.background,
    },
    seriesMetadata: {
        textAlign: 'center',
        marginHorizontal: 16,
        fontFamily: Fonts.main.regular,
        marginTop: isTablet ? 16 : 8,
    },
    lockIcon: {
        marginTop: 16,
        alignSelf: 'center',
    },

    accessibilityContainer: { flex: 1, justifyContent: 'flex-end' },
});

export default styles;
